import { render, staticRenderFns } from "./MarketingLeads.vue?vue&type=template&id=42ff023a"
import script from "./MarketingLeads.vue?vue&type=script&lang=js"
export * from "./MarketingLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports